import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MenuDashboard from '../views/MenuDashboard.vue'
import LoginView from '../views/LoginView.vue'
import AppLayout from '../layouts/AppLayout.vue'
import MetaDynamicForm from '../views/MetaDynamicForm.vue'
import CategoryPage from '../views/CategoryPage.vue'
import CategoryAttributePage from '../views/CategoryAttributePage.vue'
import CategoryAttributeOptionPage from '../views/CategoryAttributeOptionPage.vue'
import { getDefaultLandingPath, isAuthValid, isLoginRoute, isSuperAdmin, LOGIN_PATH, HOME_PATH } from '../utils/auth'

const routes = [
  {
    path: '/',
    redirect: () => getDefaultLandingPath()
  },
  {
    path: '/admin/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/labels',
    redirect: '/admin/labels'
  },
  {
    path: '/popup',
    redirect: '/admin/popup'
  },
  {
    path: '/admin',
    component: AppLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeView
      },
      {
        path: 'menu',
        name: 'menu',
        redirect: () => getDefaultLandingPath()
      },
      {
        path: 'netset',
        name: 'netset',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '系统设置', path: '/admin/home' },
            { label: '系统配置' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Config' },
      },
      {
        path: 'homeconfig',
        name: 'homeConfig',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '系统设置', path: '/admin/home' },
            { label: '首页配置' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'HomeConfig' },
      },
      {
        path: 'popup',
        name: 'popup',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '系统设置', path: '/admin/home' },
            { label: '弹窗管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Popup' },
      },

      {
        path: 'meta/list',
        name: 'metaList',
        meta: {
          breadcrumbs: [
            { label: '系统设置' },
            { label: '数据架构配置' },
            { label: '表元数据' }
          ]
        },
        component: () => import('../views/MetaListTemplate.vue')
      },
      {
        path: 'meta/form',
        name: 'metaForm',
        meta: {
          breadcrumbs: [
            { label: '系统设置' },
            { label: '数据架构配置' },
            { label: '字段配置表单' }
          ],
          overrideBreadcrumbs: true,
        },
        component: () => import('../views/MetaFormList.vue')
      },
      {
        path: 'meta-form-config-list',
        name: 'metaFormConfigList',
        meta: {
          overrideBreadcrumbs: true,
        },
        component: () => import('../views/MetaFormConfigList.vue')
      },
      {
        path: 'meta-form-config',
        name: 'metaFormConfig',
        component: () => import('../views/MetaFormList.vue')
      },
      {
        path: 'meta/menu',
        name: 'metaMenu',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '菜单管理' }
          ]
        },
        component: () => import('../views/MenuManageList.vue')
      },
      {
        path: 'meta/dictionary',
        name: 'metaDictionary',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '字典管理' }
          ]
        },
        component: () => import('../views/DictionaryManage.vue')
      },
      {
        path: 'meta/role',
        name: 'metaRole',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '角色管理' }
          ]
        },
        component: () => import('../views/MetaRole.vue')
      },
      {
        path: 'meta/admin',
        name: 'metaAdmin',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '管理员管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'Admin' }
      },
      {
        path: 'inventory',
        name: 'inventory',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '库存管理' }
          ]
        },
        component: () => import('../views/Inventory.vue')
      },
      {
        path: 'category',
        name: 'category',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '分类管理' }
          ]
        },
        component: CategoryPage
      },
      {
        path: 'labels',
        name: 'labels',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '基础配置', path: '/admin/menu' },
            { label: '标签管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Label' },
      },
      {
        path: 'category-attribute',
        name: 'categoryAttribute',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '分类管理', path: '/admin/category' },
            { label: '特殊字段配置' }
          ]
        },
        component: CategoryAttributePage
      },
      {
        path: 'category-attribute-option',
        name: 'categoryAttributeOption',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '分类管理', path: '/admin/category' },
            { label: '特殊字段配置', path: '/admin/category-attribute' },
            { label: '选项管理' }
          ]
        },
        component: CategoryAttributeOptionPage
      },
      {
        path: 'designer/audit',
        name: 'designerAudit',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '设计师管理', path: '/admin/menu' },
            { label: '设计师审核' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'DesignerAudit', initMode: 'list' },
      },
      {
        path: 'coupon',
        name: 'coupon',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '营销管理', path: '/admin/home' },
            { label: '优惠券' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Coupon' },
      },
      {
        path: 'model',
        name: 'model',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '商品管理', path: '/admin/product' },
            { label: '模型管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'ProductModel' },
      },
      {
        path: 'member/privilege',
        name: 'memberPrivilege',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '会员管理', path: '/admin/menu' },
            { label: '会员权益管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'MemberPrivilege' },
      },
      {
        path: 'vipProduct',
        name: 'vipProduct',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '会员管理', path: '/admin/menu' },
            { label: '积分商品管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'PointsProduct' },
      },
      {
        path: 'coupon/basic',
        name: 'couponBasic',
        component: MetaDynamicForm,
        props: { formCode: 'CouponBasic' },
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '营销管理', path: '/admin/home' },
            { label: '优惠券基础表' }
          ]
        }
      },
      {
        path: 'material/library',
        name: 'materialLibrary',
        meta: {
          breadcrumbs: [
            { label: '系统设置' },
            { label: '素材库' },
          ],
        },
        component: () => import('../views/MaterialLibrary.vue'),
      },
      {
        path: 'attachment',
        name: 'attachment',
        meta: {
          breadcrumbs: [
            { label: '基础配置' },
            { label: '通用设置' },
            { label: '附件管理' },
          ],
        },
        component: () => import('../views/MaterialLibrary.vue'),
      },
      {
        path: 'article',
        name: 'article',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '文章管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Article', initMode: 'list' },
      },
      {
        path: 'article/send',
        redirect: { name: 'article' },
      },
      {
        path: 'order/list',
        name: 'orderList',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '订单管理', path: '/admin/home' },
            { label: '订单列表' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Order' },
      },
      {
        path: 'product',
        name: 'product',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '商品管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'Product' }
      },
      {
        path: 'product/module',
        name: 'productModule',
        meta: {
          metadataCode: 'ProductModule',
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '商品管理', path: '/admin/product' },
            { label: '商品模块' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'ProductModule' }
      },
      {
        path: 'product/module/form',
        name: 'productModuleForm',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '商品管理', path: '/admin/product' },
            { label: '商品模块', path: '/admin/product/module' },
            { label: '商品模块编辑' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'ProductModule' }
      },
      {
        path: 'audit/handler',
        name: 'auditHandler',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '审核管理' }
          ]
        },
        component: () => import('../views/AuditHandler.vue')
      },
      {
        path: 'meta/user',
        name: 'metaUser',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '用户管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'User' }
      },
      {
        path: 'designer',
        name: 'designer',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '系统设置', path: '/admin/menu' },
            { label: '设计师管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'Designer' }
      },
      {
        path: 'designer/address',
        name: 'designerAddress',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '设计师管理', path: '/admin/designer' },
            { label: '地址管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'DesignerAddress' }
      },
      {
        path: 'address',
        name: 'address',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '收货地址管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'Address' }
      },
      {
        path: 'designer/level',
        name: 'designerLevel',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '设计师管理', path: '/admin/designer' },
            { label: '等级管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'DesignerLevel' }
      },
      {
        path: 'level/user',
        name: 'levelUser',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '基础配置', path: '/admin/menu' },
            { label: '等级管理' }
          ]
        },
        component: () => import('../views/MetaDynamicForm.vue'),
        props: { formCode: 'Level' }
      },
      {
        path: 'express/business',
        name: 'expressBusinessType',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '快递管理', path: '/admin/menu' },
            { label: '业务类型管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'ExpressBusinessType' },
      },
      {
        path: 'delivery/express',
        name: 'deliveryExpress',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/menu' },
            { label: '配送管理', path: '/admin/menu' },
            { label: '快递公司管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'DeliveryExpress' },
      },
      {
        path: 'lottery',
        redirect: '/admin/lottery/activity',
      },
      {
        path: 'lottery/activity',
        name: 'lotteryActivity',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '活动管理' },
            { label: '抽奖活动' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryActivity', lotteryDrawType: 1, pageTitle: '抽奖活动' },
      },
      {
        path: 'lottery/experience',
        name: 'lotteryExperience',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '活动管理' },
            { label: '新品体验馆' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryActivity', lotteryDrawType: 2, pageTitle: '新品体验馆' },
      },
      {
        path: 'loterry/activity',
        redirect: '/admin/lottery/activity',
      },
      {
        path: 'lottery/prize',
        name: 'lotteryPrize',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '抽奖管理' },
            { label: '奖品设置' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryPrize' },
      },
      {
        path: 'lottery/participant',
        name: 'lotteryParticipant',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '抽奖管理' },
            { label: '参与记录' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryParticipant' },
      },
      {
        path: 'lottery/draw/record',
        name: 'lotteryDrawRecord',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '抽奖管理' },
            { label: '抽奖记录' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryDrawRecord' },
      },
      {
        path: 'lottery/order',
        name: 'lotteryOrder',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '抽奖管理' },
            { label: '中奖订单' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'LotteryOrder' },
      },
      {
        path: 'card',
        name: 'card',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '小程序专有功能' },
            { label: '卡片管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'Card' },
      },
      {
        path: 'qrcode/batch',
        name: 'qrcodeBatch',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '小程序专有功能' },
            { label: '二维码批次管理' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'QrcodeBatch' },
      },
      {
        path: 'qrcode/detail',
        name: 'qrcodeDetail',
        meta: {
          isMetaForm: true,
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '小程序专有功能' },
            { label: '二维码详情' },
          ],
        },
        component: MetaDynamicForm,
        props: { formCode: 'QrcodeDetail' },
      },
      {
        path: 'statistics/index',
        name: 'statisticsIndex',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计' },
          ],
        },
        component: () => import('../views/statistics/StatisticsIndex.vue'),
      },
      {
        path: 'statistics/wxmodule',
        name: 'statisticsWxModule',
        meta: {
          reportKey: 'wxmodule',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '模块使用概览' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxgoods',
        name: 'statisticsWxGoods',
        meta: {
          reportKey: 'wxgoods',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '商品行为统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxarticle',
        name: 'statisticsWxArticle',
        meta: {
          reportKey: 'wxarticle',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '文章行为统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxactivity',
        name: 'statisticsWxActivity',
        meta: {
          reportKey: 'wxactivity',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '抽奖活动统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxpage',
        name: 'statisticsWxPage',
        meta: {
          reportKey: 'wxpage',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '页面停留统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxpoints',
        name: 'statisticsWxPoints',
        meta: {
          reportKey: 'wxpoints',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '积分商城统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxcoupon',
        name: 'statisticsWxCoupon',
        meta: {
          reportKey: 'wxcoupon',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '优惠券使用统计' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxconversion',
        name: 'statisticsWxConversion',
        meta: {
          reportKey: 'wxconversion',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '商品转化分析' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxfunnel',
        name: 'statisticsWxFunnel',
        meta: {
          reportKey: 'wxfunnel',
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '全站转化漏斗' },
          ],
        },
        component: () => import('../views/statistics/WxBehaviorStatPage.vue'),
        props: (route) => ({ reportKey: route.meta.reportKey }),
      },
      {
        path: 'statistics/wxuserusage',
        name: 'statisticsWxUserUsage',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '用户使用时长' },
          ],
        },
        component: () => import('../views/statistics/UserUsageStatPage.vue'),
      },
      {
        path: 'statistics/product',
        name: 'statisticsProduct',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: '商品销量统计' },
          ],
        },
        component: () => import('../views/statistics/ProductSalesStatPage.vue'),
      },
      {
        path: 'ops/segment-routing',
        name: 'segmentRoutingOps',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '运营运维' },
            { label: '抠图分割路由' },
          ],
        },
        component: () => import('../views/ops/SegmentRoutingOpsPage.vue'),
      },
      {
        path: 'token',
        name: 'tokenUsageStat',
        meta: {
          breadcrumbs: [
            { label: '导航', path: '/admin/home' },
            { label: '数据统计', path: '/admin/statistics/index' },
            { label: 'Token 使用' },
          ],
        },
        component: () => import('../views/statistics/TokenUsageStatPage.vue'),
      },
      {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (isLoginRoute(to.path)) {
    next()
    return
  }
  if (!isAuthValid()) {
    next({
      path: LOGIN_PATH,
      query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
    })
    return
  }
  if ((to.name === 'home' || to.path === HOME_PATH) && !isSuperAdmin()) {
    next({ path: getDefaultLandingPath() })
    return
  }
  next()
})

export default router

